import axiosWrapper from '@/utils/request'

const getConversionRate = (exporterId) => {
  return axiosWrapper({
    method: 'GET',
    url: `v1/drip_switch/rates/${exporterId}`
  })
}

const getUserConfig = (exporterId) => {
  return axiosWrapper({
    method: 'GET',
    url: `/v1/business/exporters/${exporterId}/config_details`
  })
}

const updateUserConfig = (exporterId, data) => {
  return axiosWrapper({
    method: 'POST',
    url: `/v1/business/exporters/${exporterId}/create_or_update_config`,
    data: data
  })
}

export default {
  getConversionRate,
  getUserConfig,
  updateUserConfig
}
